// extracted by mini-css-extract-plugin
export default {"title":"CasesInfo_title__jqdFU","wrapper":"CasesInfo_wrapper__p7Use","description":"CasesInfo_description__qMFHk","flex_wrapper":"CasesInfo_flex_wrapper__uA5v6"};